import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import { useState } from "react";
import { LoadingButton } from "@mui/lab";
import { useRestrictPost } from "../api/restrictPost";
import _cookies from "../../../shared/utils/_cookies";

export default function RestrictPost({
  children,
  postData,
  onSuccess = () => {},
}) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const restrictPostMutation = useRestrictPost({
    postId: postData.postagemid,
  });
  const openConfirmationDialog = () => {
    setDialogOpen(true);
  };
  const handleClose = () => {
    setDialogOpen(false);
  };

  const handleRestrictPost = () => {
    restrictPostMutation.mutate(
      {},
      {
        onSuccess: () => {
          handleClose();
          onSuccess();
        },
      }
    );
  };

  const methods = { openConfirmationDialog };
  return (
    <>
      <Dialog open={dialogOpen} onClose={handleClose} maxWidth="xs" fullWidth>
        <DialogContent>
          <DialogContentText>Restringir postagem?</DialogContentText>
          <DialogActions>
            <Button onClick={handleClose}>Cancelar</Button>
            <LoadingButton
              variant="contained"
              onClick={handleRestrictPost}
              loading={restrictPostMutation.loading}
            >
              Restringir
            </LoadingButton>
          </DialogActions>
        </DialogContent>
      </Dialog>

      {children(methods)}
    </>
  );
}
